import { useEffect } from "react";

export const useStructuredData = (key, data) => {
  const serialized = data ? JSON.stringify(data) : "";

  useEffect(() => {
    const selector = `script[data-structured-data="${key}"]`;
    const existing = document.querySelector(selector);

    if (!serialized) {
      existing?.remove();
      return undefined;
    }

    const script = existing || document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.setAttribute("data-structured-data", key);
    script.textContent = serialized;

    if (!existing) {
      document.head.appendChild(script);
    }

    return () => {
      script.remove();
    };
  }, [key, serialized]);
};